/*
 * Copyright (c) 2020.
 * Simon
 */

import {toast} from "react-toastify";
import {i18n} from "../language/i18n";
import {MY_CBOT_FAILURE, MY_EMS_KPI_FAILURE, MY_FILE_FAILURE} from "../actions/login/LoginType";
import {CONVERSATION_CREATE_ERROR} from "../containers/Facebook/LogChat/ConverstaionActionType";
import {
    TEAM_CREATE_ERROR,
    TEAM_LIST_FAILURE,
    TEAM_MEMBER_ADD_ERROR,
    TEAM_MEMBER_LIST_FAILURE,
    TEAM_MEMBER_REMOVE_ERROR, USER_AUTO_CREATE_ERROR,
    USER_UPDATE_FAILURE
} from "../containers/Team/Actions/TeamConst";
import {
    CON_EMPLOYEE_REPORT_ERROR,
    CON_LATE_MESSAGE_INDEX_ERROR,
    CON_MESSAGE_INDEX_ERROR,
    CON_REPORT_DAILY_ERROR,
    CON_REPORT_INDEX_ERROR,
    CONVERSATION_SHOW_ERROR,
    CUSTOMER_INDEX_ERROR,
    EMPLOYEE_INDEX_ERROR,
    MESSAGE_INDEX_ERROR
} from "../containers/Facebook/LogChat/Actions/LogChatConst";
import {REPORT_SWITCH_CHECK_ERROR, REPORT_SWITCH_ERROR} from "../containers/Facebook/LogChat/Upload/UploadActionType";
import {
    SHORT_LINK_CREATE_ERROR,
    SHORT_LINK_DETAIL_ERROR,
    SHORT_LINK_EDIT_ERROR,
    SHORT_LINK_LIST_ERROR
} from "../containers/ShortLink/ShortLinkConstants";
import {FILE_INDEX_ERROR} from "../containers/FileUpload/FileActionType";
import {REPLY_SEGMENT_INDEX_FAILURE} from "../containers/Ems/Segment/Reply/ReplyConst";
import {SEGMENT_DETAIL_FAILURE} from "../containers/Ems/Segment/SegmentConst";
import {
    CHAT_UPDATE_FAILURE,
    GROUP_LIST_FAILURE,
    LOGOUT_ERROR,
    MSG_CREATE_FAILURE,
    MSG_SEGMENT_CREATE_FAILURE
} from "../types";
import {EVENT_ACTIVITY_INDEX_FAILURE} from "../containers/CBot/Event/Actions/EventConst";

/**
 * @param {*} state
 * @param {*} action
 */
const ApiErrorMessageReducer = (state = {}, action) => {
    switch (action.type) {
        case CONVERSATION_CREATE_ERROR:
        case MY_EMS_KPI_FAILURE:
        case EMPLOYEE_INDEX_ERROR:
        case CON_REPORT_INDEX_ERROR:
        case CUSTOMER_INDEX_ERROR:
        case CON_MESSAGE_INDEX_ERROR:
        case CONVERSATION_SHOW_ERROR:
        case CON_EMPLOYEE_REPORT_ERROR:
        case CON_LATE_MESSAGE_INDEX_ERROR:
        case REPORT_SWITCH_ERROR:
        case REPORT_SWITCH_CHECK_ERROR:
        case CON_REPORT_DAILY_ERROR:
        case SHORT_LINK_CREATE_ERROR:
        case SHORT_LINK_EDIT_ERROR:
        case SHORT_LINK_DETAIL_ERROR:
        case SHORT_LINK_LIST_ERROR:
        case FILE_INDEX_ERROR:
        case MY_FILE_FAILURE:
        case TEAM_CREATE_ERROR:
        case MESSAGE_INDEX_ERROR:
        case TEAM_LIST_FAILURE:
        case TEAM_MEMBER_REMOVE_ERROR:
        case TEAM_MEMBER_LIST_FAILURE:
        case TEAM_MEMBER_ADD_ERROR:
        case USER_UPDATE_FAILURE:
        case REPLY_SEGMENT_INDEX_FAILURE:
        case SEGMENT_DETAIL_FAILURE:
        case GROUP_LIST_FAILURE:
        case LOGOUT_ERROR:
        case MY_CBOT_FAILURE:
        case EVENT_ACTIVITY_INDEX_FAILURE:
        case CHAT_UPDATE_FAILURE:
        case MSG_SEGMENT_CREATE_FAILURE:
        case MSG_CREATE_FAILURE:
        case USER_AUTO_CREATE_ERROR:
            let message = action.payload.message;
            toast.error(i18n.t(message));
            return {...state, action};
        default:
            return {...state};
    }
};

export {
    ApiErrorMessageReducer
}